import apiClient from './Api';
const PREFIX = '/importdms';

const createImportDMS = postData => {
  return apiClient({
    url: `${PREFIX}`,
    method: 'POST',
    data: postData
  });
};

const deleteImportDMS = postData => {
  return apiClient({
    url: `${PREFIX}`,
    method: 'DELETE',
    data: postData
  });
};

const reloadInventory = postData => {
  return apiClient({
    url: `${PREFIX}/reloadinventory`,
    method: 'POST',
    data: postData
  });
};

const listImportDMS = () => {
  return apiClient({
    url: `${PREFIX}`,
    method: 'GET'
  });
};

const importDMSService = {
  createImportDMS,
  listImportDMS,
  deleteImportDMS,
  reloadInventory
};

export default importDMSService;
